export default __webpack_public_path__ + "static/media/dreamfest (13).a34359a2.jpg";